var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.75 10.5C39.6506 10.5 42 8.15063 42 5.25C42 2.34938 39.6506 0 36.75 0C33.8494 0 31.5 2.34938 31.5 5.25C31.5 5.628 31.5446 5.99288 31.6181 6.34725L9.19012 17.5639C8.22675 16.4614 6.82762 15.75 5.25 15.75C2.34938 15.75 0 18.0994 0 21C0 23.9006 2.34938 26.25 5.25 26.25C6.82762 26.25 8.22675 25.5386 9.19012 24.4361L31.6207 35.6501C31.5446 36.0071 31.5 36.372 31.5 36.75C31.5 39.6506 33.8494 42 36.75 42C39.6506 42 42 39.6506 42 36.75C42 33.8494 39.6506 31.5 36.75 31.5C35.1724 31.5 33.7733 32.2114 32.8099 33.3139L10.3819 22.0972C10.4554 21.7429 10.5 21.378 10.5 21C10.5 20.622 10.4554 20.2571 10.3819 19.9028L32.8125 8.68875C33.7733 9.78862 35.1724 10.5 36.75 10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.3f0924c6e53e4d71242c35ae547f7008.svg";
export { ForwardRef as ReactComponent };